<template>
  <el-dialog title="新增角色成员" :visible.sync="addRole.dialogFormVisible" width="852px" height="492px">
    <div class="box_row box">
      <!-- 左侧 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="ruleForm">
        <el-form-item label="用户姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" prop="email">
          <el-input v-model="ruleForm.email" placeholder="请输入联系邮箱"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入默认密码">
            <template slot="append">
              <span>短信通知</span>
              <!-- <span v-show="!show" class="count">{{count}} s</span> -->
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="role">
          <el-checkbox-group v-model="ruleForm.role">
            <el-checkbox v-for="(el, elIndex) in roleList" :label="el" :key="elIndex">{{ el.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item class="footer">
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
      </el-form>

      <!-- 右侧 -->
      <div class="ruleForm">
        <div class="role-title">账号拥有的角色</div>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="一致性 Consistency" name="1">
            <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
            <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
          </el-collapse-item>
          <el-collapse-item title="反馈 Feedback" name="2">
            <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
            <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
          </el-collapse-item>
          <el-collapse-item title="效率 Efficiency" name="3">
            <div>简化流程：设计简洁直观的操作流程；</div>
            <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
            <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
          </el-collapse-item>
          <el-collapse-item title="可控 Controllability" name="4">
            <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
            <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addRole.dialogFormVisible = false">提交</el-button>
      <el-button @click="addRole.dialogFormVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['addRole'],
  data() {
    return {
      ruleForm: {
        name: '',
        phone: '',
        email: '',
        password: '',
        role: [],
      },
      roleList: [
        { title: '普通成员' },
        { title: '财务' },
        { title: '技术' },
        { title: '运营' },
        { title: '普通管理员' },
      ],
      rules: {
        name: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        email: [{ required: true, message: '请输入联系邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入默认密码', trigger: 'blur' }],
        role: [{ required: true, message: '请选择所属角色', trigger: 'blur' }],
      },
      activeNames: [],
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleChange(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.box_row {
  justify-content: space-between;
}
.ruleForm {
  width: 45%;
  flex-shrink: 0;
}
/deep/.el-input-group__append {
  width: 90px;
  border: 1px solid #4359b7;
  color: #4359b7;
  padding: 0;
  background: none;
  text-align: center;
  border-radius: 4px;
  left: -2px;
  cursor: pointer;
}
.role-title {
  padding-bottom: 10px;
}
.el-collapse {
  border: 1px solid #dddfe3;
}
/deep/.el-collapse-item__header {
  padding: 0 0 0 15px;
}
.dialog-footer {
  text-align: center;
  .el-button {
    padding: 8px 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
  }
}
</style>
